import { create } from 'zustand'

export const useGetScheduleTopupStore = create(set => ({
  dateExpiryStart: null,
  setDateExpiryStart: dateExpiryStart => set(() => ({ dateExpiryStart })),

  dateExpiryEnd: null,
  setDateExpiryEnd: dateExpiryEnd => set(() => ({ dateExpiryEnd })),

  scheduledTopuptData: [],
  setScheduledTopuptData: scheduledTopuptData =>
    set(() => ({ scheduledTopuptData })),

  scheduledTopuptDetails: [],
  setScheduledTopuptDetails: scheduledTopuptDetails =>
    set(() => ({ scheduledTopuptDetails })),

  showDetails: null,
  setShowDetails: showDetails => set(() => ({ showDetails })),

  resetStore: () =>
    set(() => ({
      dateExpiryStart: null,
      dateExpiryEnd: null,
      scheduledTopuptData: [],
      scheduledTopuptDetails: [],
      showDetails: null,
    })),
}))
